$(document).ready(function(){
  $(".bs-wholesale-top-learn").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".bs-wholesale-why-row").offset().top
    }, 500);
  });
  $(".bs-locations-top-learn").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".bs-pg-locations-block").offset().top
    }, 500);
  });
  $(".bs-about-top-learn").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".bs-about-imgtxt-block-title").offset().top
    }, 500);
  }); 
  $("#bs-pgaca-logo-vido").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".bs-pgaca-video-row").offset().top
    }, 500);
  }); 
  $("#bs-pgaca-logo-blog").on("click",function(e){
    e.preventDefault();
    $([document.documentElement, document.body]).animate({
      scrollTop: $(".bs-pgaca-how-row").offset().top
    }, 500);
  }); 
});